var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-page"},[_c('div',{staticClass:"layout-row"},[_c('Sidebar'),_c('div',{staticClass:"main-content d-flex flex-column"},[_c('SubscriptionsTab')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }